import { GoalStatus, GoalTimeline } from "~/../drizzle/schema";
import { cn } from "~/lib/cn";

export const GOAL_STATUS_OPTIONS = [
  { id: GoalStatus.PLANNED, label: "Not started" },
  { id: GoalStatus.IN_PROGRESS, label: "In progress" },
  { id: GoalStatus.COMPLETED, label: "Done" },
] as const;

export const GOAL_TIMELINE_OPTIONS = [
  { id: GoalTimeline.QUARTER, label: "Quarter" },
  { id: GoalTimeline.YEAR, label: "Year" },
  { id: GoalTimeline.THREE_YEARS, label: "3 years" },
] as const;

/** Badge for a goal's status: planned, in progress or completed. */
export function GoalStatusBadge({ status }: { status: GoalStatus }) {
  // The app's status tones: gray not started, amber in progress, green done.
  const styles: Record<GoalStatus, string> = {
    [GoalStatus.PLANNED]: "border-gray-200 bg-gray-50 text-gray-700",
    [GoalStatus.IN_PROGRESS]: "border-amber-200 bg-amber-50 text-amber-800",
    [GoalStatus.COMPLETED]: "border-green-200 bg-green-50 text-green-700",
  };

  return (
    <span
      className={cn(
        "shrink-0 rounded-full border px-3 py-1 text-xs font-medium whitespace-nowrap",
        styles[status],
      )}
    >
      {GOAL_STATUS_OPTIONS.find((o) => o.id === status)?.label}
    </span>
  );
}

/** Pill that shows a goal's category. */
export function GoalCategoryBadge({ category }: { category: string }) {
  return (
    <span className="max-w-full truncate rounded-full bg-purple-50 px-3 py-1 text-xs font-medium text-purple-700">
      {category}
    </span>
  );
}

/** Badge for the timeline of a Life Design goal. */
export function GoalTimelineBadge({
  timeline,
}: {
  /** Only Life Design goals have a timeline. */
  timeline: GoalTimeline | null;
}) {
  if (!timeline) return null;
  return (
    <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600">
      {GOAL_TIMELINE_OPTIONS.find((o) => o.id === timeline)?.label}
    </span>
  );
}
